import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { DashboardPage } from '@/features/dashboard';
import { currentPeriod } from '@/shared/lib/dates';

export const Route = createFileRoute('/_app/dashboard')({
  validateSearch: z.object({
    period: z
      .string()
      .regex(/^\d{4}-\d{2}$/)
      .optional(),
    view: z.enum(['management', 'sales', 'operations', 'finance']).optional(),
  }),
  staticData: { crumb: 'nav.dashboard' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'deal.view', 'Dashboard'),
  component: function Dashboard() {
    const { period, view } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <DashboardPage
        period={period ?? currentPeriod()}
        view={view ?? null}
        onPeriodChange={(p) => void navigate({ search: (prev) => ({ ...prev, period: p === currentPeriod() ? undefined : p }) })}
        onViewChange={(v) => void navigate({ search: (prev) => ({ ...prev, view: v }) })}
      />
    );
  },
});
